import { render, staticRenderFns } from "./PiquestSubjectsList.vue?vue&type=template&id=c422096a&scoped=true&"
import script from "./PiquestSubjectsList.vue?vue&type=script&lang=ts&"
export * from "./PiquestSubjectsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c422096a",
  null
  
)

export default component.exports